import { render, staticRenderFns } from "./RetailerAiProducts.vue?vue&type=template&id=16f94591&scoped=true&"
import script from "./RetailerAiProducts.vue?vue&type=script&lang=js&"
export * from "./RetailerAiProducts.vue?vue&type=script&lang=js&"
import style0 from "./RetailerAiProducts.vue?vue&type=style&index=0&id=16f94591&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f94591",
  null
  
)

export default component.exports